/******/ (function() { // webpackBootstrap
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
/**
 * Section: Product showcase
 * ------------------------------------------------------------------------------
 * Example section configuration for complete theme support.
 *
 * @namespace productShowcase
 */
/**
 * Register the `example-section` section type.
 */
var ProductShowcase = /*#__PURE__*/function (_HTMLElement) {
  function ProductShowcase() {
    var _this;
    _classCallCheck(this, ProductShowcase);
    _this = _callSuper(this, ProductShowcase);
    _this.init();
    return _this;
  }
  _inherits(ProductShowcase, _HTMLElement);
  return _createClass(ProductShowcase, [{
    key: "init",
    value: function init() {
      var _this2 = this;
      // Wait for a moment to ensure the inner element is available
      setTimeout(function () {
        // Get the inner product-showcase element
        var innerShowcase = _this2.querySelector('product-showcase');
        // Use the inner element as the root for our queries if it exists
        _this2.root = innerShowcase || _this2;

        // Now find all our elements using the correct root
        _this2.links = _this2.root.querySelectorAll('[js-product-showcase-link-id]');
        _this2.defaultImage = _this2.root.querySelector('[js-product-showcase-image="default"]');
        _this2.defaultContent = _this2.root.querySelector('[js-product-showcase-content="default"]');

        // Initialize default content as visible
        if (_this2.defaultContent) {
          _this2.defaultContent.classList.add('is-visible');
        }
        if (_this2.defaultImage) {
          _this2.defaultImage.classList.add('is-visible');
        }
        _this2.initializeLinks();
        _this2.setMinHeight();
        window.addEventListener('resize', function () {
          return _this2.setMinHeight();
        });
      }, 0);
    }
  }, {
    key: "initializeLinks",
    value: function initializeLinks() {
      var _this3 = this;
      this.links.forEach(function (link) {
        link.addEventListener('mouseenter', function () {
          var id = link.getAttribute('js-product-showcase-link-id');
          _this3.updateContent(id);
        });
        link.addEventListener('mouseleave', function () {
          _this3.resetContent();
        });
      });
    }
  }, {
    key: "updateContent",
    value: function updateContent(id) {
      // First remove is-visible from all images and content
      var allImages = this.root.querySelectorAll('[js-product-showcase-image]');
      var allContent = this.root.querySelectorAll('[js-product-showcase-content], [js-product-showcase-content-id]');
      allImages.forEach(function (image) {
        image.classList.remove('is-visible');
      });
      allContent.forEach(function (content) {
        content.classList.remove('is-visible');
      });

      // Make sure default image is hidden when showing a selected image
      if (this.defaultImage) {
        this.defaultImage.classList.remove('is-visible');
      }

      // Show selected content
      var selectedContent = this.root.querySelector("[js-product-showcase-content-id=\"".concat(id, "\"]"));
      var selectedImage = this.root.querySelector("[js-product-showcase-image=\"".concat(id, "\"]"));
      if (selectedContent) {
        selectedContent.classList.add('is-visible');
      }
      if (selectedImage) {
        selectedImage.classList.add('is-visible');
      }
    }
  }, {
    key: "resetContent",
    value: function resetContent() {
      // First remove is-visible from all images and content
      var allImages = this.root.querySelectorAll('[js-product-showcase-image]');
      var allContent = this.root.querySelectorAll('[js-product-showcase-content], [js-product-showcase-content-id]');
      allImages.forEach(function (image) {
        image.classList.remove('is-visible');
      });
      allContent.forEach(function (content) {
        content.classList.remove('is-visible');
      });

      // Show default content
      if (this.defaultContent) {
        this.defaultContent.classList.add('is-visible');
      }
      if (this.defaultImage) {
        this.defaultImage.classList.add('is-visible');
      }
    }
  }, {
    key: "setMinHeight",
    value: function setMinHeight() {
      var contentWrapper = this.root.querySelector('[js-product-showcase-content-wrapper]');
      if (!contentWrapper) return;
      var defaultContent = contentWrapper.querySelector('[js-product-showcase-content="default"]');
      var dynamicContents = contentWrapper.querySelectorAll('.product-showcase__dynamic');

      // Get heights of all content elements
      var heights = [defaultContent].concat(_toConsumableArray(dynamicContents)).map(function (el) {
        return (el === null || el === void 0 ? void 0 : el.offsetHeight) || 0;
      });

      // Set min-height to the maximum height found
      var maxHeight = Math.max.apply(Math, _toConsumableArray(heights));
      contentWrapper.style.minHeight = "".concat(maxHeight + 20, "px");
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('product-showcase', ProductShowcase);
/******/ })()
;